import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import CurrentBiddings from '../views/CurrentBiddings';
import CurrentShowings from '../views/showing/CurrentShowings';
import SingleObjectBidding from '../views/CurrentBiddingsSingleListing';
import SingleShowingObject from '../views/showing/CurrentShowingSingleListing';
import store from '../store'
import NewBidding from '../views/NewBidding';
import ListingsNeedsShowing from '../views/showing/ListingsNeedsShowing';

Vue.use(VueRouter)

const routes = [
  {
    path: '/visningar',
    name: 'CurrentShowings',
    component: CurrentShowings
  },
  {
    path: '/visningar/object/:id',
    name: 'singleshowingobject',
    component: SingleShowingObject,
  },
  {
    path: '/visningar/ny-visning',
    name: 'ListingsNeedsShowing',
    component: ListingsNeedsShowing
  },
  {
    path: '/mina-budgivningar/ny-budgivning',
    name: 'NewBidding',
    component: NewBidding
  },
  {
    path: '/mina-budgivningar',
    name: 'CurrentBiddings',
    component: CurrentBiddings
  },
  {
    path: '/mina-budgivningar/object/:id',
    name: 'singlebiddingobject',
    component: SingleObjectBidding,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: "Logga in"
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  /**
   * This will preserve scroll position when going back/forward,
   * otherwise scrolled to top.
   */
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

router.afterEach((to) => {
  /**
   * Redirect to login if not signed in, need provide callback here
   * to avoid duplicate navigation error for some reason...
   */
  if (!store.state.authenticated && to.name !== "login") {
    router.push('/login', () => {});
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'FasAd Mobile'
  next();
});

export default router
